export default __webpack_public_path__ + "static/media/users.a80b7a3f.svg";